export default "/assets/images/problem-solved-01.ab1df31a4f78ed47.png";